module.exports = "<div class=\"header\"></div>\n\n<br>\n\n<div fxLayout=\"row\" fxLayoutAlign=\"center start\" class=\"mat-typography\">\n    <div fxFlex=\"50%\" fxFlex.xs=\"95%\">\n        <h3 class=\"mat-subheading-2 white-text\">Users</h3>\n        <app-users-list></app-users-list>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /zeit/1e2f5901/src/app/dashboard/dashboard.component.html
// module id = ../../../../../src/app/dashboard/dashboard.component.html
// module chunks = main